module.exports = {"TXTCLI_How_to_play":{"id":"TXTCLI_How_to_play","defaultMessage":"Como Jogar"}}